"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEmpty = void 0;
const fromPairs = require("lodash/fromPairs");
const removeEmpty = (obj) => obj === null
    ? null
    : obj === undefined
        ? undefined
        : fromPairs(Object.entries(obj)
            .filter(([_, v]) => v != null)
            .map(([k, v]) => [k, v === Object(v) ? (0, exports.removeEmpty)(v) : v]));
exports.removeEmpty = removeEmpty;
//# sourceMappingURL=removeEmpty.js.map